export default __webpack_public_path__ + "static/media/menu-black.af9ad0c3.svg";